import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; // Importa il file per la registrazione del service worker
import { setupTranslationGuard } from "./utils/translationGuard";

import { ThemeProvider } from "@material-tailwind/react";

setupTranslationGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {/* <React.StrictMode> */}
    <ThemeProvider>
      <App />
    </ThemeProvider>
    {/* </React.StrictMode> */}
  </>,
);

// Registra il service worker con l'opzione di aggiornamento forzato
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      window.location.reload();
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
